import { Timestamp } from '@angular/fire/firestore';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { AlbumImage } from '../../models/image.album.model';

export const getAlbumImages = createAction(
  '[AlbumImage] Get Album Images',
  props<{
    groupId: string;
    albumId: string;
    lastRecord?: Timestamp;
    limitRecords?: number;
  }>(),
);

export const addOneToStore = createAction(
  '[AlbumImage] Add to store',
  props<{ image: AlbumImage }>(),
);
export const addManyToStore = createAction(
  '[AlbumImage] Add Many to store',
  props<{ images: AlbumImage[] }>(),
);

export const getAlbumImagesFailure = createAction(
  '[AlbumImage] Get Album Images Failure',
  props<{ error: AppExceptionModel }>(),
);

export const tagUser = createAction(
  '[AlbumImage] Tag User',
  props<{
    groupId: string;
    imageId: string;
    albumImage: Partial<AlbumImage>;
  }>(),
);
export const tagUserFailure = createAction(
  '[AlbumImage] Tag User failure',
  props<{ error: AppExceptionModel }>(),
);
export const tagUserSuccess = createAction(
  '[AlbumImage] Tag User success',
  props<{
    groupId: string;
    imageId: string;
    albumImage: AlbumImage;
  }>(),
);

export const deleteImage = createAction(
  '[AlbumImage] Delete',
  props<{ groupId: string; albumId: string; imageId: string }>(),
);
export const deleteFailure = createAction(
  '[AlbumImage] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[AlbumImage] Delete success',
  props<{ groupId: string; imageId: string }>(),
);

export const clearFromStore = createAction(
  '[AlbumImage] Clear from store',
  props<{ ids: string[] }>(),
);

export const clear = createAction('[AlbumImage] Clear Images');
